// extracted by mini-css-extract-plugin
export var callCard = "_p1-0";
export var callMessageButton = "_p1-1";
export var helpIcon = "_p1-3";
export var helpIconContainer = "_p1-4";
export var verticalDivider = "_p1-2";